import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Autocomplete, Chip } from '@mui/material';

const SearchSelectFields = ({
  label,
  name,
  options,
  defaultValue,
  onSelected,
  hintValue,
  formik,
  disabled = false,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedValues, setSelectedValues] = useState(defaultValue || []);

  useEffect(() => {
    if (defaultValue) {
      // Set the initial selected values based on defaultValue prop
      setSelectedValues(defaultValue);
      // Set search term to the labels of the default selected values
      const labels = defaultValue.map((item) => item.label).join(', ');
      setSearchTerm(labels);
    }
  }, [defaultValue]);

  // Function to handle search input and filter options
  const handleSearch = (event) => {
    const inputValue = event.target.value;
    setSearchTerm(inputValue);

    // Clear error message if user starts typing
    if (formik && inputValue) {
      formik.setFieldError(name, undefined); // Clear the error
    }
  };

  // Function to handle multiple selections
  const handleSelectionChange = (event, newValues) => {
    setSelectedValues(newValues);
    onSelected(newValues); // Pass selected values to the parent component
    if (formik) {
      formik.setFieldValue(name, newValues); // Update Formik field value
      formik.setFieldTouched(name); // Mark the field as touched
      // Set error if no values are selected
      if (newValues.length > 0) {
        formik.setFieldError(name, undefined); // Clear error if values are present
      }
      // else {
      //formik.setFieldError(name, "At least one option must be selected");
      // }
    }
  };

  // Function to handle chip deletion
  const handleChipDelete = (chipToDelete) => {
    const newSelectedValues = selectedValues.filter(
      (chip) => chip.value !== chipToDelete.value,
    );
    setSelectedValues(newSelectedValues);
    onSelected(newSelectedValues); // Update parent with the new list
    if (formik) {
      formik.setFieldValue(name, newSelectedValues); // Update Formik field value
      formik.setFieldTouched(name); // Mark the field as touched
    }
  };

  return (
    <Autocomplete
      multiple
      value={selectedValues} // Set the selected values (multiple)
      options={options}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      noOptionsText="Không tìm thấy"
      disabled={disabled}
      onChange={handleSelectionChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          value={searchTerm}
          onChange={handleSearch}
          variant="outlined"
          error={formik && !!(formik.touched[name] && formik.errors[name])} // Error handling
          helperText={formik && formik.touched[name] && formik.errors[name]} // Helper text for errors
          InputProps={
            selectedValues.length > 0
              ? {
                  ...params.InputProps,
                  startAdornment: selectedValues.map((option, index) => (
                    <Chip
                      key={index}
                      label={option.label}
                      onDelete={() => handleChipDelete(option)}
                      sx={{ ml: 0.5, mr: 1, mt: 0.5, mb:0.5 }}
                    />
                  )),
                }
              : { ...params.InputProps }
          }
          //focused={Boolean(hintValue) || (selectedValues.length > 0)}
          placeholder={hintValue ? String(hintValue) : ''}
          InputLabelProps={{
            shrink: hintValue ? true : undefined, // Force shrink if displayHint is present
          }}
        />
      )}
    />
  );
};

SearchSelectFields.propTypes = {
  formik: PropTypes.object,
};

export default SearchSelectFields;
